import { api } from "../_services";
import {
  modalAlert,
  configurationList,
  notePermission,
  noteCreatePermission,
  noteMergePermission,
  noteBulkResolvePermission,
  reportCreatePermission,
} from "../_actions";
import _ from "lodash";

export function getConfiguration(token) {
  return dispatch => {
    const url = "/api/v1/configuration/";
    return api.getFetch(url, "", token).then(json => {
      if (json.ok === false) {
        //if fetch error, error modal pop up.
        json.errorMsg = "Unable to get the configuration details.";
        dispatch(modalAlert(json));
      } else {
        dispatch(configurationList(json));
        if (json.permissions !== undefined && json.permissions.notes !== null && json.permissions.notes.length > 0) {
          //set parent notes permission
          if (
            _.find(json.permissions.notes, item => {
              return item.can_view_notes === true;
            })
          ) {
            dispatch(notePermission(true));
          } else {
            dispatch(notePermission(false));
          }
          //check through the permission list to check if the user is eligible to create notes
          if (
            _.find(json.permissions.notes, item => {
              return item.can_create_notes === true;
            })
          ) {
            dispatch(noteCreatePermission(true));
          } else {
            dispatch(noteCreatePermission(false));
          }
          //check through the permission list to check if the user is eligible to merge notes
          if (
            _.find(json.permissions.notes, item => {
              return item.can_merge_notes === true;
            })
          ) {
            dispatch(noteMergePermission(true));
          } else {
            dispatch(noteMergePermission(false));
          }
          //check through the permission list to check if the user is eligible to bulk resolve notes
          if (
            _.find(json.permissions.notes, item => {
              return item.can_resolve_notes === true;
            })
          ) {
            dispatch(noteBulkResolvePermission(true));
          } else {
            dispatch(noteBulkResolvePermission(false));
          }
        } else {
          dispatch(notePermission(false));
        }
        if (
          json.permissions !== undefined &&
          json.permissions.reports !== null &&
          json.permissions.reports.length > 0
        ) {
          //check through the permission list to check if the user is eligible to create notes
          if (
            _.find(json.permissions.reports, item => {
              return item.can_create_reports === true;
            })
          ) {
            dispatch(reportCreatePermission(true));
          } else {
            dispatch(reportCreatePermission(false));
          }
        }
        return json;
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/_services/config.service.js